import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import PlaceholderImage from 'src/assets/images/inventoryEmptyPlaceholder.svg';
const FlexWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
const ImageWrapper = styled.div`
  width: 260px;
  height: 160px;
`;
const Notice = styled.div`
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: ${({
  theme
}) => theme.color.content8};
`;
const Empty: React.FC = () => {
  const {
    t
  } = useTranslation();
  return <FlexWrapper data-sentry-element="FlexWrapper" data-sentry-component="Empty" data-sentry-source-file="Empty.tsx">
      <ImageWrapper data-sentry-element="ImageWrapper" data-sentry-source-file="Empty.tsx">
        <PlaceholderImage data-sentry-element="PlaceholderImage" data-sentry-source-file="Empty.tsx" />
      </ImageWrapper>
      <Notice data-sentry-element="Notice" data-sentry-source-file="Empty.tsx">{t('inventory_empty_text')}</Notice>
    </FlexWrapper>;
};
export default Empty;